<template>
  <div id="app">
    <router-view/>
    <div id="plusfriend-addfriend-button" @click="msgBtnClick"></div>
  </div>
</template>

<script>

  export default {
    methods: {
      msgBtnClick(){
        Kakao.PlusFriend.chat({
          plusFriendId: '_dDZFj' // 플러스친구 홈 URL에 명시된 id로 설정합니다.
        });
      }
    }      
  }
</script>

<style>

@import url(https://cdn.jsdelivr.net/gh/moonspam/NanumSquare@1.0/nanumsquare.css);

body { margin: 0; }

* { font-family: 'NanumSquare', 'Avenir', Helvetica, Arial, sans-serif; outline: none; word-break: keep-all; }

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

input { border-radius: 0; border: 0; box-shadow: 0; }
input::placeholder { opacity: .3; }

.main-wrap { position: fixed; left: 0; right: 0; top: 0; bottom: 0; }

#plusfriend-addfriend-button { position: fixed; left: 20px; bottom: 20px; width: 40px; height: 40px; border-radius: 50%; background: #ddd url("./assets/kakaoLogo.svg") center no-repeat; background-size: 60%; }
@media screen and (max-width: 640px) {
  #plusfriend-addfriend-button { left: 1rem; bottom: 1rem; width: 3rem; height: 3rem;}
}

</style>
